<template>
  <div class="d-flex align-center gap-2" data-testid="materiality-header">
    <h3 data-testid="materiality-header__title">
      {{  $nova.labelsName('materiality_page','threshold_label','Materiality') }}
    </h3>
    <div>
      <v-tooltip bottom content-class="tooltip-bottom">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="shadow-off mr-2"
            icon
            @click="$emit('refresh',{page:0,reload:true})"
            data-testid="materiality-header__refresh-button"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Refresh</span>
      </v-tooltip>
    </div>
   <v-spacer></v-spacer>
    <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          data-testid="materiality-header__activity-log-btn" 
          icon  
          class="grey--text text--lighten-1" 
          v-bind="attrs"
          v-on="on"
          @click.stop="$emit('pending-approval-list')"
        >
          <img data-testid="materiality-header__activity-log-icon" src="/img/icons/ActivityLogICon.svg" alt="Activity Log" />
        </v-btn>
      </template>
      <span>Pending Approval List</span>
    </v-tooltip>
    <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          data-testid="materiality-header__faq-btn" 
          icon  
          class="grey--text text--lighten-1" 
          v-bind="attrs"
          v-on="on"
          @click.stop="$emit('open-faq')"
        >
          <img data-testid="materiality-header__faq-icon" src="/img/icons/CommentICon.svg" alt="FAQ" />
        </v-btn>
      </template>
      <span>FAQ</span>
    </v-tooltip>
    <!-- Column Selection Menu -->
    <v-menu 
      data-testid="materiality-header__columns-menu" 
      offset-y 
      transition="slide-y-transition" 
      :close-on-content-click="false" 
      scrollable 
      max-height="250"
      max-width="300"
    >
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip data-testid="materiality-header__columns-tooltip" left content-class="tooltip-left">
          <template v-slot:activator="{ on: tooltip }">
            <v-btn 
              data-testid="materiality-header__columns-btn" 
              icon  
              class="grey--text text--lighten-1" 
              v-bind="attrs" 
              v-on="{ ...tooltip, ...menu }"
            >
              <img data-testid="materiality-header__columns-icon" src="/img/icons/MenuIcon.svg" alt="Select Columns" />
            </v-btn>
          </template>
          <span>Select Columns</span>
        </v-tooltip>
      </template>
      <div class="pt-2 white" data-testid="materiality-header__columns-list">
        <div class="pa-1">
          <v-checkbox 
            data-testid="materiality-header__column-checkbox"
            v-for="(option, index) in selectableHeaders" 
            :key="index" 
            class="pa-2 mt-0 pt-0" 
            dense 
            scrollable
            :input-value="selectedColumns.includes(option.value)"
            hide-details 
            @change="toggleColumn(option.value)"
          >
            <template v-slot:label>
              <span>{{ option.text }}</span>
            </template>
          </v-checkbox>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'MaterialityHeader',
  props: {
    /**
     * Array of header objects for the data table
     * Each header should have: value, text, and optionally lock property
     */
    headers: {
      type: Array,
      default: () => []
    },
    /**
     * Array of currently visible column values
     */
    visibleColumns: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pageName: "my_reporting_units_page",
      selectedColumns: []
    };
  },
  computed: {
    /**
     * Returns headers that can be toggled (lock !== true or lock is false)
     * @returns {Array} Array of selectable header objects
     */
    selectableHeaders() {
      return this.headers.filter((header) => header.lock !== true);
    }
  },
  watch: {
    /**
     * Sync selectedColumns with visibleColumns prop
     */
    visibleColumns: {
      immediate: true,
      handler(newVal) {
        this.selectedColumns = [...newVal];
      }
    }
  },
  methods: {
    /**
     * Toggles a column's visibility
     * @param {String} columnValue - The value of the column to toggle
     */
    toggleColumn(columnValue) {
      const index = this.selectedColumns.indexOf(columnValue);
      if (index > -1) {
        // Remove from selection
        this.selectedColumns.splice(index, 1);
      } else {
        // Add to selection
        this.selectedColumns.push(columnValue);
      }
      this.onColumnSelectionChange();
    },
    /**
     * Emits column selection change to parent component
     */
    onColumnSelectionChange() {
      this.$emit('update:visibleColumns', [...this.selectedColumns]);
      this.$emit('columns-change', [...this.selectedColumns]);
    }
  }
}
</script>



<!-- <template>
  <div class="materiality-header">
    <div class="d-flex flex-column gap-5">
      <div class="d-flex">
        <h3>{{ $nova.labelsName('materiality_page','threshold_label','Materiality') }}</h3>
        <v-spacer></v-spacer>
        <v-tooltip bottom content-class='tooltip-bottom'>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" name="faq" @click.stop="$emit('open-faq')" icon>
            <v-icon>mdi-frequently-asked-questions</v-icon>
          </v-btn>
        </template>
        <span class="noTransform">FAQ</span>
      </v-tooltip>
      <v-tooltip bottom content-class="tooltip-bottom">
        <template v-slot:activator="{ on }">
          <v-btn class="mx-0 px-0" icon v-on="on" @click="$emit('refresh')">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Refresh</span>
      </v-tooltip>
        </div>
        <div class="d-flex gap-1">
        <h2 class="font-weight-medium">{{ count }}</h2>
        <span class="">{{ $nova.labelsName('materiality_page','ru_entity_plural_label','Reporting Units') }}<br />{{ $nova.labelsName('materiality_page','commentary_count_label','Count') }}</span>
        <v-spacer></v-spacer>
        
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaterialityHeader',
  props: {
    count: {
      type: Number,
      default: 0
    }
  }
}
</script> -->
